export enum ExecutionStatus {
  All = 'all',
  Pending = 'pending',
  Preprocessing = 'preprocessing',
  Active = 'active',
  ActiveWithErrors = 'active_with_errors',
  RerunPreparing = 'rerun_preparing',
  Rerunning = 'rerunning',
  Completed = 'completed',
  PartiallyCompleted = 'completed_with_errors',
  Cancelled = 'cancelled',
  Errors = 'errors',
  AskUser = 'ask_user',
}

export const ActiveStatuses = [
  ExecutionStatus.Preprocessing,
  ExecutionStatus.Pending,
  ExecutionStatus.Active,
  ExecutionStatus.ActiveWithErrors,
  ExecutionStatus.RerunPreparing,
  ExecutionStatus.Rerunning,
];
